import { useEffect, useState } from "react";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import ExhibitionHighlights from "./ExhibitionHighlights"; // Import the new component
import { getExhibitions, getExhibitionById } from "./request"; // Adjust path
import ExhibitionsCarousel from "./ExhibitionsCarousel"; // Create similar to DiariesCarousel


export default function Exhibition() {
  const [exhibitions, setExhibitions] = useState([]);
  const [selectedExhibition, setSelectedExhibition] = useState(null);
  const [contents, setContents] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [loading, setLoading] = useState(false);


  // Fetch all exhibitions and set the latest as default
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getExhibitions();
        if (response?.Result) {
          const sorted = [...response.Exhibitions].sort(
            (a, b) => parseInt(b.year) - parseInt(a.year),
          );
          setExhibitions(sorted);

          const latest = sorted[0];
          setSelectedExhibition(latest); // set initially

          if (latest?.id) {
            const detailed = await getExhibitionById(latest.id);
            if (detailed?.Result) {
              setContents(detailed.Contents || []);
              setSelectedExhibition(detailed.Exhibition); // for consistency
              setSelectedContent(detailed.Contents[0] || null); // Select first content by default
            }
          }
        }
      } catch (err) {
        console.error("Failed to fetch exhibition data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Load contents + exhibition details for given ID
  const handleExhibitionSelect = async (exhibition) => {
    if (exhibition?.id === selectedExhibition?.id) return;

    setLoading(true);
    try {
      const detailed = await getExhibitionById(exhibition.id);
      if (detailed?.Result) {
        setSelectedExhibition(detailed.Exhibition);
        setContents(detailed.Contents || []);
        setSelectedContent(detailed.Contents[0] || null);
      }
    } catch (err) {
      console.error("Failed to fetch selected exhibition data", err);
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setLoading(false);
    }
  };

  const handleContentClick = (content) => {
    setSelectedContent(content);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid" />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="bg-white min-h-screen w-full mt-5 px-5 sm:px-10 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal">
        <div className="pt-10 sm:pt-16 md:pt-20">
          {/* Exhibition Highlights Section */}
          <div className="bg-primaryBG  rounded-3xl py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-10 lg:px-20">

          {selectedExhibition && <ExhibitionHighlights exhibition={selectedExhibition} />}
          </div>

          {/* Muqadma Section */}
          {selectedExhibition?.muqadma && (
            <div className="flex flex-col items-center mt-12 mb-20">
              <p className="font-nastaleeqRegular text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-3">
                مقدمہ
              </p>
              <div
                className="w-full text-center text-lg sm:text-xl md:text-xl lg:text-2xl p-6 rounded-3xl group"
                dangerouslySetInnerHTML={{ __html: selectedExhibition.muqadma }}
              />
            </div>
          )}

          {/* Contents List (Row Tabs) */}
          {contents.length > 0 && (
            <div className="flex flex-col items-center mt-12 transition-all duration-300">
              <p className="font-nastaleeqRegular text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-6">
                مواد
              </p>
              <div className="flex flex-wrap justify-center gap-4 w-full max-w-screen-lg px-4">
                {contents.map((content) => (
                  <button
                    key={content.id}
                    onClick={() => handleContentClick(content)}
                    className={`px-6 py-3 rounded-full text-base sm:text-lg md:text-xl lg:text-2xl transition-all duration-300 ${
                      selectedContent?.id === content.id
                        ? 'bg-primary text-white shadow-lg'
                        : 'bg-gray-200 text-black hover:bg-primary hover:text-white'
                    }`}
                  >
                    {content.title}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Selected Content Display */}
          {selectedContent && (
            <div className="mt-8 bg-primaryBG rounded-3xl py-8 px-5 sm:px-10 md:px-10 lg:px-20">
              <h2 className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl mb-4">
                {selectedContent.title}
              </h2>
              <div
                className="text-lg sm:text-xl md:text-xl lg:text-2xl flex item-center justify-center text-center"
                dangerouslySetInnerHTML={{ __html: selectedContent.content }}
               
              />
            </div>
          )}

          {/* Previous Exhibitions Carousel */}
          <div className="p-4 mt-12 flex justify-center">
            <ExhibitionsCarousel
              exhibitions={exhibitions}
              selectedExhibition={selectedExhibition}
              handleExhibitionSelect={handleExhibitionSelect}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}